//import * as Helper from "../../../../utils/Helper";
import ApiService from "../../../ApiService";

const EditService = {
    loadScreenView: (id, successCallback, failureCallback) => {
        ApiService.post("/web/admin/contact/edit/loadscreenview", { id }, successCallback, failureCallback);
    },
    saveContact: (vo, successCallback, failureCallback) => {
        ApiService.post("/web/admin/contact/edit/savecontact", vo, successCallback, failureCallback);
    }
};

export default EditService;